// ©2024 Austin App House. All rights reserved.
import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";

export const useDataTable = (entity, options = {}) => {
  const [pending, setPending] = React.useState(true);
  const [initial, setInitial] = useState(true)
  const [data, setData] = useState({})
  const [page, setPage] = useState(options.page ?? 1)
  const [startDate, setStartDate] = useState(options.startDate ?? 0)
  const [endDate, setEndDate] = useState(options.endDate ?? 0)
  const [companyName, setCompanyName] = useState(options.companyName ?? '')
  const [perPage, setPerPage] = useState(options.perPage ?? 5)
  const [sortBy, setSortBy] = useState(options.sortBy ?? 'updatedAt')
  const [sortDirection, setSortDirection] = useState(options.sortDirection ?? -1)
  const [filters, setFilters] = useState(options.filters ?? {})

  const { columns, isReload } = options

  const params = {
    page,
    sortBy,
    sortDirection,
    perPage,
    startDate,
    endDate,
    companyName,
    filters
  }

  const refetch = useCallback(() => {
    setPending(true)
    axios.get(entity, {params})
      .then(res => res.data)
      .then(setData)
      .catch(() => setData({}))
  }, [entity, params])

  const context = {
    refetch,
    columns,
    data,
    page,
    setPage,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    perPage,
    setPerPage,
    setFilters,
    setStartDate,
    setEndDate,
    setCompanyName,
    pending
  }

  useEffect(() => {
    if (initial) {
      setInitial(false)
    }
  }, [initial])

  useEffect(() => {
    if (!options.actions) {
      return undefined;
    }
    columns.push({
      button: true,
      width: '150px',
      center: true,
      cell: options.actions
    })
    return undefined;
  }, [options.actions])

  useEffect(() => {
    if (initial) {
      return undefined;
    }
    setPending(false)
    return undefined;
  }, [data, initial])

  useEffect(() => {
    if (initial) {
      return undefined;
    }
    setPage(1)
    return undefined;
  }, [sortBy, sortDirection, perPage, filters, initial])

  useEffect(() => {
    refetch()
  }, [page, perPage, filters, sortBy, sortDirection, isReload])

  return {...context, context}
}